import { useCallback } from 'react';
import api from '../services/api';
import { useApi } from './useApi';

interface Subscription {
  _id: string;
  user: string;
  plan: 'starter' | 'standard' | 'advanced';
  billingCycle: 'monthly' | 'yearly';
  status: 'inactive' | 'active' | 'cancelled' | 'past_due';
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
}

interface CheckoutResult {
  checkoutUrl: string;
  sessionId: string;
}

export function useCreateCheckout() {
  const createFn = useCallback(
    async (plan: string, billingCycle: string = 'monthly'): Promise<CheckoutResult> => {
      const { data } = await api.post('/subscriptions/checkout', { plan, billingCycle });
      return data.data;
    },
    [],
  );

  return useApi<CheckoutResult>(createFn);
}

export function useMySubscription() {
  const fetchFn = useCallback(async (): Promise<Subscription> => {
    const { data } = await api.get('/subscriptions/me');
    return data.data.subscription;
  }, []);

  return useApi<Subscription>(fetchFn);
}